var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNutrition(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 172,
    viewBox: "0 0 156 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_402_539)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.124,
    y: 33,
    width: 89.751,
    height: 106.069,
    rx: 4.89551,
    fill: "url(#paint0_linear_402_539)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_402_539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3915 125.019L60.1673 124.962V125.453L59.025 125.716L59.1735 125.499V132.935H58.1226L53.7362 125.956L53.8733 125.944V132.41L53.7019 132.204L54.8556 132.444V132.935H52.0913V132.444L53.245 132.204L53.0737 132.41V125.499L53.1993 125.704L52.0913 125.51V125.019L54.1931 124.962L58.5224 131.827L58.3853 131.838V125.499L58.5452 125.704L57.3915 125.51V125.019Z",
    fill: "url(#paint1_linear_402_539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3998 133.038C62.8972 133.038 62.4822 132.882 62.1548 132.57C61.8273 132.257 61.6636 131.778 61.6636 131.13V127.486L61.7778 127.646L60.7612 127.429V126.938L62.5774 126.87V130.97C62.5774 131.427 62.684 131.766 62.8972 131.987C63.1105 132.208 63.396 132.318 63.754 132.318C64.0357 132.318 64.3403 132.242 64.6678 132.09C64.9952 131.937 65.3189 131.701 65.6387 131.382L65.5702 131.587V127.464L65.6844 127.646L64.6678 127.429V126.938L66.484 126.858V132.375L66.3469 132.227L67.375 132.421V132.924L65.7758 132.992L65.6387 131.861L65.7644 131.907C65.3912 132.295 64.9952 132.581 64.5764 132.764C64.1652 132.947 63.773 133.038 63.3998 133.038Z",
    fill: "url(#paint2_linear_402_539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1178 133.038C69.7218 133.038 69.4096 132.916 69.1811 132.672C68.9527 132.421 68.8385 132.044 68.8385 131.541V127.395L68.987 127.543H67.8104V127.041L68.9984 126.87L68.8385 127.052V125.544L69.7523 125.396V127.052L69.6266 126.904H71.42L71.3858 127.543H69.6266L69.7523 127.395V131.416C69.7523 131.736 69.8132 131.968 69.9351 132.113C70.0645 132.257 70.2435 132.33 70.4719 132.33C70.609 132.33 70.7575 132.307 70.9174 132.261C71.0773 132.215 71.2487 132.151 71.4314 132.067L71.6256 132.592C71.0849 132.889 70.5823 133.038 70.1178 133.038Z",
    fill: "url(#paint3_linear_402_539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2345 132.935V132.444L73.2397 132.227L73.1255 132.398V127.475L73.2512 127.646L72.2345 127.429V126.938L73.8337 126.858L73.9594 127.978L73.8337 127.932C74.1764 127.574 74.5115 127.296 74.8389 127.098C75.1664 126.9 75.5243 126.801 75.9127 126.801C76.1564 126.801 76.4115 126.839 76.678 126.915L76.6095 128.583H76.0383L75.9013 127.384L76.0041 127.589C75.9508 127.574 75.8936 127.563 75.8327 127.555C75.7718 127.547 75.7109 127.543 75.65 127.543C75.3453 127.543 75.0484 127.635 74.759 127.818C74.4772 128 74.2069 128.236 73.948 128.526L74.0393 128.252V132.398L73.9023 132.227L75.1474 132.444V132.935H72.2345Z",
    fill: "url(#paint4_linear_402_539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9476 132.353L78.8448 132.227L79.8386 132.444V132.935H77.1428V132.444L78.1366 132.227L78.0338 132.353V127.532L78.1251 127.635L77.1428 127.429V126.938L78.9476 126.87V132.353ZM78.4221 125.636C78.247 125.636 78.1023 125.579 77.9881 125.465C77.8738 125.35 77.8167 125.194 77.8167 124.996C77.8167 124.791 77.8738 124.634 77.9881 124.528C78.1099 124.414 78.2584 124.357 78.4336 124.357C78.6163 124.357 78.7648 124.41 78.8791 124.516C78.9933 124.623 79.0504 124.783 79.0504 124.996C79.0504 125.202 78.9895 125.362 78.8676 125.476C78.7458 125.583 78.5973 125.636 78.4221 125.636Z",
    fill: "url(#paint5_linear_402_539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5669 133.038C82.1709 133.038 81.8587 132.916 81.6303 132.672C81.4018 132.421 81.2876 132.044 81.2876 131.541V127.395L81.4361 127.543H80.2595V127.041L81.4475 126.87L81.2876 127.052V125.544L82.2014 125.396V127.052L82.0758 126.904H83.8691L83.8349 127.543H82.0758L82.2014 127.395V131.416C82.2014 131.736 82.2623 131.968 82.3842 132.113C82.5136 132.257 82.6926 132.33 82.921 132.33C83.0581 132.33 83.2066 132.307 83.3665 132.261C83.5265 132.215 83.6978 132.151 83.8806 132.067L84.0748 132.592C83.5341 132.889 83.0315 133.038 82.5669 133.038Z",
    fill: "url(#paint6_linear_402_539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4885 132.353L86.3857 132.227L87.3794 132.444V132.935H84.6836V132.444L85.6774 132.227L85.5746 132.353V127.532L85.666 127.635L84.6836 127.429V126.938L86.4885 126.87V132.353ZM85.963 125.636C85.7879 125.636 85.6432 125.579 85.5289 125.465C85.4147 125.35 85.3576 125.194 85.3576 124.996C85.3576 124.791 85.4147 124.634 85.5289 124.528C85.6508 124.414 85.7993 124.357 85.9744 124.357C86.1572 124.357 86.3057 124.41 86.4199 124.516C86.5341 124.623 86.5913 124.783 86.5913 124.996C86.5913 125.202 86.5303 125.362 86.4085 125.476C86.2866 125.583 86.1382 125.636 85.963 125.636Z",
    fill: "url(#paint7_linear_402_539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0102 126.801C91.8479 126.801 92.5028 127.064 92.9749 127.589C93.4547 128.115 93.6946 128.857 93.6946 129.817C93.6946 130.464 93.5765 131.031 93.3405 131.519C93.112 131.998 92.7846 132.372 92.3581 132.638C91.9317 132.905 91.4176 133.038 90.816 133.038C89.9936 133.038 89.3501 132.783 88.8856 132.273C88.421 131.755 88.1888 131.012 88.1888 130.045C88.1888 129.375 88.2992 128.8 88.52 128.32C88.7485 127.833 89.0721 127.46 89.491 127.201C89.9174 126.934 90.4238 126.801 91.0102 126.801ZM90.9645 127.475C90.3781 127.475 89.9288 127.696 89.6166 128.137C89.3044 128.579 89.1483 129.2 89.1483 129.999C89.1483 130.784 89.2968 131.374 89.5938 131.77C89.8908 132.166 90.3172 132.364 90.8731 132.364C91.2767 132.364 91.6156 132.265 91.8898 132.067C92.1715 131.861 92.381 131.572 92.518 131.199C92.6627 130.826 92.7351 130.38 92.7351 129.862C92.7351 129.086 92.5789 128.495 92.2667 128.092C91.9621 127.681 91.528 127.475 90.9645 127.475Z",
    fill: "url(#paint8_linear_402_539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6563 132.935V132.444L95.6844 132.215L95.5473 132.387V127.475L95.6844 127.646L94.6563 127.429V126.938L96.2555 126.858L96.3812 127.978L96.2555 127.932C96.6363 127.543 97.0323 127.258 97.4435 127.075C97.8623 126.892 98.2583 126.801 98.6315 126.801C99.1341 126.801 99.5491 126.957 99.8766 127.269C100.212 127.574 100.375 128.05 100.368 128.697V132.387L100.254 132.227L101.259 132.444V132.935H98.5972V132.444L99.591 132.227L99.4539 132.398V128.891C99.4539 128.419 99.3473 128.073 99.1341 127.852C98.9209 127.631 98.6353 127.521 98.2774 127.521C97.9956 127.521 97.6872 127.597 97.3521 127.749C97.0247 127.901 96.701 128.137 96.3812 128.457L96.4611 128.275V132.398L96.3469 132.238L97.3179 132.444V132.935H94.6563Z",
    fill: "url(#paint9_linear_402_539)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_402_539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.6689 90.9302C87.6813 90.9302 94.9873 83.6242 94.9873 74.6118C94.9873 65.5994 87.6813 58.2935 78.6689 58.2935C69.6566 58.2935 62.3506 65.5994 62.3506 74.6118C62.3506 83.6242 69.6566 90.9302 78.6689 90.9302Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9859 74.6118C94.9859 65.6908 87.8266 58.4468 78.9404 58.3002V90.9232C87.8266 90.7767 94.9859 83.5327 94.9859 74.6118Z",
    fill: "#EAA22F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6688 85.4906C84.677 85.4906 89.5476 80.62 89.5476 74.6118C89.5476 68.6036 84.677 63.733 78.6688 63.733C72.6606 63.733 67.79 68.6036 67.79 74.6118C67.79 80.62 72.6606 85.4906 78.6688 85.4906Z",
    fill: "#FFEDB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5464 74.6118C89.5464 68.6951 84.8222 63.885 78.9404 63.7397V85.484C84.822 85.3386 89.5464 80.5285 89.5464 74.6118Z",
    fill: "#FEE187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.84 67.5724H99.6387V76.454H100.84V67.5724Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.24 89.7801C101.244 89.7801 102.057 88.9667 102.057 87.9632V76.0522C102.057 75.0489 101.244 74.2354 100.24 74.2354C99.2369 74.2354 98.4233 75.0487 98.4233 76.0522V87.9632C98.4233 88.9667 99.2369 89.7801 100.24 89.7801Z",
    fill: "#FF7F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.082 65.7197V59.45C104.082 59.0841 103.808 58.7561 103.442 58.7371C103.053 58.7167 102.73 59.0267 102.73 59.4117V64.5942C102.73 64.8981 102.484 65.1443 102.18 65.1437C101.935 65.1433 101.647 65.1427 101.402 65.1424C101.099 65.1419 100.854 64.8958 100.854 64.5929V59.4498C100.854 59.0839 100.58 58.7559 100.215 58.737C99.8249 58.7165 99.5027 59.0266 99.5027 59.4116V64.5927C99.5027 64.8958 99.2578 65.1418 98.9546 65.1422C98.7098 65.1425 98.4217 65.143 98.1765 65.1436C97.8726 65.144 97.6262 64.8978 97.6262 64.5941V59.4498C97.6262 59.0839 97.3523 58.7559 96.9868 58.737C96.5972 58.7165 96.2749 59.0266 96.2749 59.4116V65.7196C96.2749 67.3626 97.6068 68.6945 99.2498 68.6945H100.178C100.178 68.6945 100.178 68.6945 100.178 68.6945C100.179 68.6945 100.179 68.6945 100.179 68.6945H101.107C102.75 68.6943 104.082 67.3628 104.082 65.7197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.76 67.4426H56.5566V76.3425H57.76V67.4426Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7061 65.2163C52.7061 62.7582 54.6986 58.5406 57.1564 58.5406C59.6143 58.5406 61.6068 62.7582 61.6068 65.2163C61.6068 67.6743 59.6143 69.6667 57.1564 69.6667C54.6986 69.6667 52.7061 67.6743 52.7061 65.2163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1562 89.6939C58.1616 89.6939 58.977 88.8786 58.977 87.8732V75.9378C58.977 74.9324 58.1616 74.117 57.1562 74.117C56.1508 74.117 55.3354 74.9324 55.3354 75.9378V87.8732C55.3356 88.8788 56.1508 89.6939 57.1562 89.6939Z",
    fill: "#FF7F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_402_539",
    x: 0.487305,
    y: 0.363281,
    width: 155.024,
    height: 171.343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_402_539",
    x: 19.4546,
    y: 94.9835,
    width: 114.441,
    height: 73.9548,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_402_539",
    x: 20.0693,
    y: 28.9204,
    width: 116.649,
    height: 97.9102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.917647 0 0 0 0 0.635294 0 0 0 0 0.184314 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_539",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_539",
    x1: 77.9995,
    y1: 33,
    x2: 77.9995,
    y2: 139.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#2C2C2C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_539",
    x1: 39.4488,
    y1: 135.935,
    x2: 113.607,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_402_539",
    x1: 39.4488,
    y1: 135.935,
    x2: 113.607,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_402_539",
    x1: 39.4488,
    y1: 135.935,
    x2: 113.607,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_402_539",
    x1: 39.4488,
    y1: 135.935,
    x2: 113.607,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_402_539",
    x1: 39.4488,
    y1: 135.935,
    x2: 113.607,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_402_539",
    x1: 39.4488,
    y1: 135.935,
    x2: 113.607,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_402_539",
    x1: 39.4488,
    y1: 135.935,
    x2: 113.607,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_402_539",
    x1: 39.4488,
    y1: 135.935,
    x2: 113.607,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_402_539",
    x1: 39.4488,
    y1: 135.935,
    x2: 113.607,
    y2: 135.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutrition);
export default __webpack_public_path__ + "static/media/nutrition.85130e45e9277c2550be25e4d5c04d8a.svg";
export { ForwardRef as ReactComponent };